import { twMerge } from "tailwind-merge"
export const bodyDefaultSyles = "text-[1rem] md:text-[1.125rem] font-bold leading-1.5"

const BodyDefault: React.FC<React.HTMLAttributes<HTMLSpanElement>> = ({ className, ...props }) => {
  return <p className={twMerge(bodyDefaultSyles, "my-[1.25rem] md:my-[1.5rem]", className)} {...props} />
}

export default BodyDefault
